import { Credit } from '@/models/credit';
import { OrderReturn as OrderReturnStore, OrderReturnCustomer } from '@/models/order';
import { OrderReturnData } from '@/services/api/models/order';

import ReturnedProduct from './ReturnedProduct';

export default class OrderReturn implements OrderReturnStore {
  public createdOn: string;
  public credit?: Partial<Credit>;
  public customer: Partial<OrderReturnCustomer>;
  public orderDisplay: string | null;
  public notes: string | null;
  public orderNumber: string | null;
  public processedBy: number;
  public returnedProducts: ReturnedProduct[];
  public seller: number;
  public shortId: string;
  public status: string;
  public total: string;
  public uuid: string;

  constructor(data: OrderReturnData) {
    this.createdOn = data.createdOn;
    this.credit = typeof data.credit === 'number' ? { id: data.credit } : { ...data.credit };
    this.customer = typeof data.customer === 'number' ? { id: data.customer } : { ...data.customer };
    this.notes = data.notes;
    this.orderNumber = data.order; // the full uuid of the original order
    this.orderDisplay = data.orderDisplay; // the user-defined value to display for an order id
    this.processedBy = data.processedBy;
    this.returnedProducts = (data.returnedProducts || []).map((product) => new ReturnedProduct(product));
    this.seller = data.seller;
    this.shortId = data.shortId; // the last 8 chars of the orderReturn uuid
    this.status = data.status;
    this.total = data.total;
    this.uuid = data.uuid; // the orderReturn number
  }
}
